import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress/nprogress'
import store from '@/store'
import versionTimer, { isNewerVersionAvailable } from '@/versionTimer'
import alertTimer, { fetchWarningMessage } from '@/alertTimer'
import routes from './routes'

NProgress.configure({ showSpinner: false })

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (routeTo, routeFrom, next) => {
  NProgress.start()

  alertTimer.runTimersCheck()

  if (!routeFrom.name) {
    // checking version on initial app load to prevent showing notification on freshly opened page
    const needFullReload = await isNewerVersionAvailable()

    if (needFullReload) {
      window.location.reload()
    }

    await fetchWarningMessage()
  } else {
    versionTimer.runTimersCheck()
  }

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  if (authRequired && routeTo.name !== 'logout') {
    if (store.getters['auth/loggedIn']) {
      // on initial app load
      if (!routeFrom.name) {
        try {
          await Promise.all([
            store.dispatch('auth/fetchPrivileges'),
            store.dispatch('customers/fetchCustomers')
          ])

          if (routeTo.name !== 'customers') {
            await store.dispatch('jobs/setTimer', true)
          }
        } catch (e) {
          return next({ name: 'logout' })
        }
      }
    } else {
      return next({ name: 'login' })
    }

    if (routeTo.name !== 'customers' && !store.getters['customers/customerGuid']) {
      return next({ name: 'customers' })
    }
  }

  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()
})

router.onError(e => {
  NProgress.done()
})

export default router
